import axios from 'axios';
import {
  GET_STAND_ALONE_PAGE_DATA,
  GET_STAND_ALONE_PAGE_SECTIONS_DATA,
} from '../../lib/graphql/constants/masterClass.gql';
import gql from '../../lib/graphql/gql';

// getStandAlonePageSectionData
export async function getStandAlonePageSectionData(slug: string) {
  
  return await gql({
    query: GET_STAND_ALONE_PAGE_SECTIONS_DATA,
    variables: { slug: slug },
    queryName: 'standAlonePageDataBySlug',
    queryType: 'query-without-edge',
    context: 'get stand alone page data',
  });
}

// getStandAlonePageData
export async function getStandAlonePageData(slug: string) {
  return await gql({
    query: GET_STAND_ALONE_PAGE_DATA,
    variables: { filter: { slug: { eq: slug }, status: { is: true } } },
    queryName: 'standAlonePages',
    queryType: 'query',
    context: 'get stand alone page sections data',
  });
}

// getStandAlonePageProps
export async function getStandAlonePageProps(slug: string) {
  // getStandAlonePageData
  const page = await getStandAlonePageData(slug);
  if (!page.length) {
    return {
      notFound: true,
    };
  }
  // sections
  const sections = await getStandAlonePageSectionData(slug);
  
  if (!sections.length) {
    return {
      notFound: true,
    };
  }
  return {
    page: page && page[0],
    sections,
  };
}
